import * as React from "react";
import { connect } from "react-redux";

import { pollForReward } from "../../actions";
import {
  CouponCode as CouponCodeComponent,
  CouponCodeProps,
} from "../../components/CouponCode/CouponCode";
import { StoreState } from "../../reducers";
import {
  getAccountCreditRedeem,
  getTransactionId,
} from "../../reducers/methods";

const waitTime = 10000;

interface TransactionCouponContainerProps extends CouponCodeProps {
  pollForReward: typeof pollForReward;
  redeemStatus: ReturnType<typeof getAccountCreditRedeem>;
  transactionId: string;
}

interface ContainerState {
  status: "error" | "pending" | "polling" | "timeout";
}

// Mimics Coupon Code component behavior for exchange redemptions
// essentially swaps getReward for transaction long poll
class TransactionCouponCode extends React.Component<
  TransactionCouponContainerProps,
  ContainerState
> {
  constructor(props: TransactionCouponContainerProps) {
    super(props);
    this.state = { status: "pending" };
  }

  componentDidUpdate() {
    this.pollForReward();
    setTimeout(this.timeout, waitTime);
  }

  pollForReward = () => {
    const coupon = this.props.redeemStatus
      ? this.props.redeemStatus.code
      : undefined;
    if (this.state.status === "pending" && !coupon) {
      if (this.props.transactionId) {
        this.props.pollForReward({ transactionId: this.props.transactionId });
        this.setState({ status: "polling" });
      }
    }
  };

  timeout = () => {
    const noReturn = this.props.redeemStatus && !this.props.redeemStatus.code;

    // We're good
    if (this.props.redeemStatus.code) {
      return;
    }

    // error with redemption
    if (
      this.state.status === "pending" ||
      this.props.redeemStatus.status === "error"
    ) {
      this.setState({ status: "error" });
    }
    // long poll timeout
    if (this.state.status === "polling" && noReturn) {
      this.setState({ status: "timeout" });
    }
  };

  render() {
    const { redeemStatus } = this.props;

    let componentStatus = (redeemStatus && redeemStatus.status) || "";

    // long poll returned
    if (this.state.status === "polling" && componentStatus) {
      // long poll returned without a code
      if (componentStatus === "success" && !redeemStatus.code) {
        this.setState({ status: "timeout" });
        componentStatus = "error";
      }
    }

    if (this.state.status === "timeout") {
      componentStatus = "timeout";
    }

    if (this.state.status === "error") {
      componentStatus = "error";
    }

    const code = redeemStatus ? redeemStatus.code : "";

    return (
      <CouponCodeComponent
        {...this.props}
        status={componentStatus}
        coupon={code}
      />
    );
  }
}

function mapStateToProp(
  state: StoreState,
  props: TransactionCouponContainerProps
) {
  return {
    redeemStatus: getAccountCreditRedeem(state),
    transactionId: getTransactionId(state),
  };
}

export default connect(mapStateToProp, {
  pollForReward,
})(TransactionCouponCode);
